<template>
  <div id="product-detail-container">
    <v-container class="product-detail-top-container" fluid>
      <image-slider v-if="displaySlider === true"></image-slider>
      <product-header></product-header>
      <product-price></product-price>
      <product-description></product-description>
    </v-container>

    <button-bottom v-bind:page="page" v-bind:quantity="getSelectedQuantity"></button-bottom>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import ImageSlider from './imageSlider'
import ProductHeader from './productHeader'
import ProductDescription from './productDescription'
import ButtonBottom from './bottom/index.vue'
import ProductPrice from './productPrice/index.vue'

export default {
  name: 'ProductDetail',
  props: {
    staticUrl: {
      default: '',
      type: String
    },
    displaySlider: false
  },
  data () {
    return {
      page: 'detail'
    }
  },
  components: {
    ImageSlider,
    ProductHeader,
    ProductDescription,
    ButtonBottom,
    ProductPrice
  },
  computed: {
    ...mapGetters([
      'getSelectedQuantity'
    ])
  },
  methods: {
    ...mapActions({
      getProductByStaticUrlAPI: 'getProductByStaticUrlAPI'
    })
  },
  created () {
    this.getProductByStaticUrlAPI(this.staticUrl).then(() => {
      this.displaySlider = true
    })
  }
}
</script>

<style type='text/css' lang='scss' scoped>
.container {
  padding: 14px;
}
.product-detail-top-container {
  height: calc(100% - 52px);
  overflow: auto;
}
#product-detail-container {
  background-color: #eeeeee;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/index.vue